import { useQuery } from '@tanstack/react-query';

import { SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import Group from 'models/Group';
import { GroupAccessMode, groupsQueryKeys, indexGroups } from 'services/api/group';

// Stable identity for the unresolved state — avoids creating a new [] on every render,
// which would invalidate downstream memos and effects that depend on the result. Typed as the
// resolved element type (Group) so consumers get the full facility shape, not just {id, name}.
const EMPTY_FACILITIES: Group[] = [];

// The buildings the current user may address a referral to. Referral creation, referral
// editing, and portal-retrieval facility entry all offer exactly this set, so they share
// one query key and one cache entry rather than fetching the same list under three names.
const PARAMS = {
  accessModes: [GroupAccessMode.Allowed],
  type: SKILLED_NURSING_FACILITY,
  pageSize: 200,
  sortBy: 'name',
};

export function useAllowedFacilities() {
  const query = useQuery({
    queryKey: [...groupsQueryKeys.index, PARAMS],
    queryFn: ({ signal }) => indexGroups(PARAMS, signal),
  });

  return { facilities: query.data?.data ?? EMPTY_FACILITIES, isPending: query.isPending };
}
